<template>
    <div class="compo-form-item">
        <div class="compo-form-name">
            <label class="compo-form-title">충전정보</label>
        </div>
        <div class="compo-form-body">
            <table class="key-value">
                <tr>
                    <th>충전금액</th>
                    <td>{{Number(chargingYescoin).toLocaleString()}}원</td>
                </tr>
                <tr>
                    <th>거래 후 잔액</th>
                    <td>{{Number(afterCoinBalance).toLocaleString()}}원</td>
                </tr>
                <tr>
                    <th>결제수단</th>
                    <td>{{paymentOption}}</td>
                </tr>
            </table>
        </div>
        <div class="compo-info-box">
            - 예스코인 충전 안내사항 1 입니다.<br>
            - 예스코인 충전 안내사항 2 입니다.<br>
            - 예스코인 충전 안내사항 3 입니다.
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    components: {
    },
    props:{
        chargingYescoin: null,      // 충전금액
        afterCoinBalance: null,     // 충전 후 잔액
        paymentOption: {            // 결제 수단..

        }   
    },

    data() {
        return {            
        }
    },

    computed: {
		...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
        }),
	},

}
</script>

<style lang="scss" scoped>
@import '@/assets/css/order.scss';

</style>